import { useState } from "react";

import { useCall } from "../state/CallProvider";
import { CallCard } from "./CallCard";
import { CallList } from "./CallList";
import { Contacts } from "./Contacts";
import { Dialpad } from "./Dialpad";
import { LoginScreen } from "./LoginScreen";
import { Settings } from "./Settings";
import { IconClock, IconGear, IconKeypad, IconLogout, IconUser } from "./icons";

type Tab = "phone" | "calls" | "contacts" | "settings";

export function Softphone() {
  const { state, logout, setAgentStatus } = useCall();
  const [tab, setTab] = useState<Tab>("phone");

  if (state.auth.status !== "loggedIn") return <div className="sp"><LoginScreen /></div>;

  const inCall = !!state.call && state.status !== "idle";
  const online = state.agentStatus === "available";

  return (
    <div className="sp">
      <header className="sp-head">
        <span className="sp-ava" aria-hidden><IconUser size={16} /></span>
        <div className="sp-head-id">
          <span className="sp-agent">{state.auth.agent?.name ?? "Agent"}</span>
          <button className="sp-presence" onClick={() => setAgentStatus(online ? "offline" : "available")}
            title="Toggle availability">
            <span className={"sp-dot " + state.agentStatus} />
            {online ? "Available" : "Offline"}
          </button>
        </div>
        <button className="sp-logout" onClick={logout} title="Sign out" aria-label="Sign out"><IconLogout size={16} /></button>
      </header>

      {state.error && <div className="sp-err">{state.error}</div>}
      {!online && !inCall && (
        <div className="sp-offline">You're offline — go online to receive calls.</div>
      )}

      <div className="sp-body">
        {inCall ? <CallCard /> : (
          <>
            {tab === "phone" && <Dialpad />}
            {tab === "calls" && <CallList entries={state.history} />}
            {tab === "contacts" && <Contacts />}
            {tab === "settings" && <Settings />}
          </>
        )}
      </div>

      {!inCall && (
        <nav className="sp-tabs">
          <button className={"sp-tab" + (tab === "phone" ? " on" : "")} onClick={() => setTab("phone")}>
            <IconKeypad size={18} />Phone
          </button>
          <button className={"sp-tab" + (tab === "calls" ? " on" : "")} onClick={() => setTab("calls")}>
            <IconClock size={18} />Calls
          </button>
          <button className={"sp-tab" + (tab === "contacts" ? " on" : "")} onClick={() => setTab("contacts")}>
            <IconUser size={18} />Contacts
          </button>
          <button className={"sp-tab" + (tab === "settings" ? " on" : "")} onClick={() => setTab("settings")}>
            <IconGear size={18} />Settings
          </button>
        </nav>
      )}
    </div>
  );
}
